import { render, staticRenderFns } from "./DetailNew.vue?vue&type=template&id=f6206f9c&scoped=true"
import script from "./DetailNew.vue?vue&type=script&lang=js"
export * from "./DetailNew.vue?vue&type=script&lang=js"
import style0 from "./DetailNew.vue?vue&type=style&index=0&id=f6206f9c&prod&lang=scss&scoped=true"
import style1 from "./DetailNew.vue?vue&type=style&index=1&id=f6206f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6206f9c",
  null
  
)

export default component.exports